import { ContentType } from "@/types";

const CONTENT_TYPES: ContentType[] = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "image/vnd.adobe.photoshop",
  "video/mp4",
  "video/quicktime",
  "video/x-msvideo",
  "video/webm",
  "model/obj",
  "model/glb",
  "model/gltf-binary",
  "model/gltf+json",
  "audio/mp3",
  "audio/mpeg",
  "audio/wav",
  "audio/aac",
  "application/toml",
  "application/octet-stream",
  "unknown",
];

export const isContentType = (value: unknown): value is ContentType => {
  return (
    typeof value === "string" &&
    Object.values(CONTENT_TYPES).includes(value as ContentType)
  );
};
